import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage23___Kinnita_tellimus from "./pages/Webpage23___Kinnita_tellimus";
import Webpage3Lehte_ei_leitud from "./pages/Webpage3Lehte_ei_leitud";
import Webpage5Tellimus_kinnitatud from "./pages/Webpage5Tellimus_kinnitatud";
import Webpage81___Vali_piletid_Naissaarele from "./pages/Webpage81___Vali_piletid_Naissaarele";
import Webpage102___Vali_lisateenused from "./pages/Webpage102___Vali_lisateenused";

var baseURL = 'https://monica.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0IiwianRpIjoiMjc2YWQyMGNmYmYyMmI3NmQzNzliMjU5ZTU1NmI3ZGM0OWQwYzQ1YTJhZWI0ZTlhZmViNTA2MGE0ODNjZWMyMzg1MDc0YzBhYTcyOTE2YTIiLCJpYXQiOjE3ODQ0NDM4NjIuOTcwNDczLCJuYmYiOjE3ODQ0NDM4NjIuOTcwNDc2LCJleHAiOjE3ODQ1MzAyNjIuOTY3NjUxLCJzdWIiOiI4Iiwic2NvcGVzIjpbXX0.fUojwAxlfsgE6NMpXw4PCCQyvQpRAaKhi0vnTA5aTaWIHXtRNxCxa5WU5nAxph7LiS6JxTHfw5hzpmuCqtt21VNl9Kd34SoeEjWLohWbyTi6qbbVoujU12VqKYHNdPv-Zimcev_OqFS1Qbdsd_72UPzfhsyCRea1QPiq-0lbCUdmaLxRn0Q6xoqqhOtmvfH29J3qn4L72BFv6EbDyUt0rXbOB_0cfwqPzRD7_0N5XDcDX8ajz_z1pV_RO6H-2FBBl1GobPmHhBGlYMuOrbr4llmpJOzRdv4XeQOfCJhmw-DsxDCbf9n0K5icDU9GlCaiORVH5nap2BqHmewyz2BjcYiuJD-JCC3Wwzyz92NA90MXtBklLiI4uYkN_XrGVVH5Kc_o08tLFWX3zLTkVYXiKt-yaT6jOmsmJEpD9KDlPcmTXaWGmMFT-PpxLYgDsmg6FfBAK4SjLtFiB4VexdKJkXYDeEDg4XCw5GYZ9-NarupNNG1N69vmO7csLz8SyLX5dkFDPFakA1d51CB_4NdKtw_EUW6rD9dVUS6XuJ9k3kc5alnGQYELWMzZpjE-Yi66v2GaOIxpz-CnxqgEPfMgG6mm4HgoihJd4Z8BAMCOwdi7N3BYf1FYdMQzXS3jAYlPgX8DS_KIe-vHV_Ox8WfvTjOF3ebHd9mGZwAWo8rxCS4',
    'Access-api-key': "eyJpdiI6InZvdU1CK3hWTWsyOFN3Njl6WUpiTWc9PSIsInZhbHVlIjoibjFIdU03NW9Gd0ZKWjVrem81b0hjQT09IiwibWFjIjoiYTE2NzQ5YTQ3MmZiYTQwMGI3OTdmZGMwMDlmNGY0MWZlNjczMjQzZTkwODU1ZjZlNDI4MWIzMjIzNDk2M2I3NiIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6IkRTUkZJQ3hRL0xqYmplVU9zNDVKOWc9PSIsInZhbHVlIjoiSms3anpXVStlTnpSUUxiY05ZQXNWZz09IiwibWFjIjoiZWE4YzQ2ZWNhNDkzMTg2Zjc0NmU3YzI0MDAxZThhOTE1ZjAyOGNhNWJhMGJjOWE3NjY4Y2YwM2I2NDJiZWQyZiIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: ""
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/vormista-tellimus" element={<Webpage23___Kinnita_tellimus />} exact />;
                                                                    <Route path="/et/*" element={<Webpage3Lehte_ei_leitud />} exact />;
                                                <Route path="*" element={<Webpage3Lehte_ei_leitud />} exact />;
                                                                    <Route path="/et/tellimus-kinnitatud" element={<Webpage5Tellimus_kinnitatud />} exact />;
                                                                    <Route path="/et/" element={<Webpage81___Vali_piletid_Naissaarele />} exact />;
                                                                    <Route path="/et/lisateenused" element={<Webpage102___Vali_lisateenused />} exact />;
                                                                
                                                            </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}